import { useState, useEffect } from 'react';
import {
EditTwoTone,
CloseOutlined,
DoubleLeftOutlined,
LeftOutlined,
RightOutlined,
DoubleRightOutlined,
EditOutlined
} from '@ant-design/icons';
import './EditPanelModal.css';

const EditPanelModal = ({
    isOpen,
    onClose,
    onSave,
    title,
    items,
    selectedItems,
    setSelectedItems,
    itemRenderer,
    itemsPerPage = 16,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [allItems, setAllItems] = useState([]);
    const [tempSelectedItems, setTempSelectedItems] = useState([...selectedItems]);

    useEffect(() => {
        const selectedIds = new Set(selectedItems.map((item) => item.id));
        const selected = items.filter((item) => selectedIds.has(item.id));
        const unselected = items
        .filter((item) => !selectedIds.has(item.id))
        .sort((a, b) => a.name.localeCompare(b.name));

        setAllItems([...selected, ...unselected]);
        setTempSelectedItems([...selectedItems]);
        setCurrentPage(1);
    }, [items, selectedItems, isOpen]);

    const totalPages = Math.ceil(allItems.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedItems = allItems.slice(startIndex, startIndex + itemsPerPage);

    const handleItemToggle = (itemId, isSelected) => {
        if (isSelected) {
        setTempSelectedItems((prev) => prev.filter((item) => item.id !== itemId));
        } else {
        const itemToAdd = items.find((item) => item.id === itemId);
        if (itemToAdd) {
            setTempSelectedItems((prev) => [...prev, itemToAdd]);
        }
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
        setCurrentPage(newPage);
        }
    };

    const handleSave = () => {
    // Pass the current tempSelectedItems back to the parent's onSave handler
    onSave(tempSelectedItems);
    onClose(); // Close the modal after saving
    };

    return (
        <>
        {isOpen && <div className="panel-overlay" onClick={onClose} />}

        <div className={`edit-panel-modal ${isOpen ? 'open' : ''}`}>
            <div className="panel-header">
            <h2 className="panel-title">{title}</h2>
            <div className="panel-actions">
                <button className="save-btn" onClick={handleSave}>
                {/* <EditOutlined style={{ fontSize: 16 }} /> */}
                Save
                </button>
                <button className="close-btn" onClick={onClose}>
                <CloseOutlined style={{ fontSize: 18 }} />
                </button>
            </div>
            </div>

            <div className="panel-content">
            <div className="items-section">
                {allItems.length === 0 ? (
                <div className="no-data-message">No data available</div>
                ) : (
                <>
                    <div className="items-list">
                    {paginatedItems.map((item) => {
                        const isSelected = tempSelectedItems.some(
                        (selected) => selected.id === item.id
                        );
                        return (
                        <div key={item.id} className="item-row">
                            {itemRenderer(item)}
                            <div className="item-checkbox">
                            <input
                                type="checkbox"
                                id={`item-${item.id}`}
                                checked={isSelected}
                                onChange={() =>
                                handleItemToggle(item.id, isSelected)
                                }
                            />
                            <label htmlFor={`item-${item.id}`}></label>
                            </div>
                        </div>
                        );
                    })}
                    </div>

                    {totalPages > 1 && (
                    <div className="pagination">
                        <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                        >
                        <DoubleLeftOutlined />
                        </button>
                        <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        >
                        <LeftOutlined />
                        </button>
                        <div className="pagination-info">
                        <span>Page</span>
                        <input
                            type="number"
                            value={currentPage}
                            onChange={(e) =>
                            handlePageChange(Number(e.target.value))
                            }
                            min="1"
                            max={totalPages}
                            className="page-input"
                        />
                        <span>of</span>
                        <span>{totalPages}</span>
                        </div>
                        <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        >
                        <RightOutlined />
                        </button>
                        <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        >
                        <DoubleRightOutlined />
                        </button>
                    </div>
                    )}
                </>
                )}
            </div>
            </div>
        </div>
        </>
    );
};

export default EditPanelModal;
